import { Component } from 'react';
import {actions, Control, Errors} from 'forms/rrf';
import PropTypes from 'prop-types';
import { Button, FormControl, FormGroup, FormLabel, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {validators} from '../../../../utils/validators';

class RequiredTextarea extends Component {
  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };
  changeAction = (model, value) => (dispatch) => {
    dispatch(actions.change(model, value));
    dispatch(actions.resetValidity(model));
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value);
    }
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      model, label, controlId, errorLabel, tooltip, ...props
    } = this.props;

    return (
      <FormGroup controlId={controlId} className={`form-group${this.state[errorLabel] ? ` has-${this.state[errorLabel]}` : ''}`}>
        {label && (
          <FormLabel>
            {label}
            *
          </FormLabel>
        )}
        {
          tooltip && (
            <OverlayTrigger
              overlay={(
                <Tooltip className="tooltip" id="tooltip">
                  {tooltip}
                </Tooltip>
              )}
              placement="left"
            >
              <Button variant="default" className="tip float-end">
                ?
              </Button>
            </OverlayTrigger>
          )
        }

        <Control.textarea
          changeAction={this.changeAction}
          component={FormControl}
          as="textarea"
          model={model}
          validators={{required: validators.required(this.updateErrors, errorLabel)}}
          {...props}
        />

        <Errors
          className="errors"
          messages={{
            required: 'This field is required',
            patternMismatch: 'Value does not match the required pattern'
          }}
          model={model}
          show={{
            touched: true,
            focus: false
          }}
        />
      </FormGroup>
    );
  }
}

RequiredTextarea.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  pattern: PropTypes.string,
  controlId: PropTypes.string,
  placeholder: PropTypes.string,
  errorLabel: PropTypes.string,
  tooltip: PropTypes.string,
};

RequiredTextarea.defaultProps = {
  controlId: Math.random()
    .toString(16)
    .substring(2),
  errorLabel: 'error',
};

export default RequiredTextarea;
